"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HBScrollCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
class HBScrollCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.HBScroll);
    }
    static parse(_args) {
        return new HBScrollCommand();
    }
}
exports.HBScrollCommand = HBScrollCommand;
